<template>
  <div class="class-member">
    <!--<above-nav></above-nav>-->
    <div class="content-wrapper">
      <div class="content">
        <router-link tag="div" to="/console/lesson/class" class="back">< {{$t('m.class_back')}}</router-link>
        <div class="classinfo-wrapper">
          <img class="info-img" :src="imgprefix+lessoninfo.faceimg" alt="img" width="180" height="120">
          <div class="classinfo-text-wrapper">
            <h2 class="classinfo-text-title">
              {{decodeURIComponent(classinfo.classmodename)}}-{{decodeURIComponent(classinfo.classname)}}</h2>
            <p class="classinfo-text-row">
              课程标题:{{decodeURIComponent(lessoninfo.lessonname)}}
            </p>
            <p class="classinfo-text-row" v-if="classHourInfo!=null&& classinfo.democlass=='0'">
              预计剩余课次:{{classHourInfo.classnums}}次<span class="split"></span>已上完课时:{{computeTotalHour(classHourInfo.finishedclasshour)}}<span
              class="split"></span>总课时:{{computeTotalHour(classHourInfo.classhour)}}
            </p>

          </div>
        </div>
        <middle-nav :list="middleList"></middle-nav>
        <div class="member-wrapper">
          <p class="enrollnum">{{$t('m.class_mem_list')}}{{totoalPage}}{{$t('m.class_mem_list2')}}</p>
          <template v-if="classinfo.democlass=='0'">
            <p class="hint" v-if="!totoalPage">{{$t('m.class_mem_noresult')}}</p>
            <div class="list-wrapper">
              <template v-for="(item,index) in costList">
                <div class="list">
                  <img src="./avatar.png" alt="avatar" width="110" height="110">
                  <div class="text-wrapper">
                    <p class="name">{{decodeURIComponent(item.username)}}</p>
                    <p class="phone">{{item.phone}}</p>
                    <p class="pay">{{$t('m.class_mem_haspayed')}}{{item.paymoney}}{{$t('m.yuan')}}</p>
                  </div>
                  <p class="time">{{$t('m.class_mem_registration_time')}}{{item.addtime}}</p>
                </div>
              </template>
            </div>
          </template>
          <template v-if="classinfo.democlass=='1'">
            <div class="filter-wrapper">
              <el-radio-group v-model="radioSelect">
                <el-radio label="显示全部">{{$t('m.class_mem_showall')}}</el-radio>
                <el-radio label="选择时间查找">{{$t('m.class_mem_search')}}</el-radio>
              </el-radio-group>
              <template v-if="timepickShow">
                <el-date-picker
                  class="timepicker"
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  unlink-panels
                  size="mini">
                </el-date-picker>
                <span class="search" @click="search">{{$t('m.class_mem_search_text')}}</span>
              </template>
            </div>
            <p class="hint" v-if="!totoalPage">{{$t('m.class_mem_noresult')}}</p>
            <template v-for="(item,index) in freeList">
              <div class="time-title">
                <span class="opendate">{{item.time}}</span>
                <div class="list-wrapper no-margin">
                  <template v-for="(item,index) in item.list">
                    <div class="list">
                      <img src="./avatar.png" alt="avatar" width="110" height="110">
                      <div class="text-wrapper">
                        <p class="name">{{decodeURIComponent(item.username)}}</p>
                        <p class="phone">{{item.phone}}</p>
                        <p class="pay">{{$t('m.class_mem_haspayed')}}{{item.paymoney}}{{$t('m.yuan')}}</p>
                      </div>
                      <p class="time">{{$t('m.class_mem_registration_time')}}{{item.addtime}}</p>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <div class="pagenav-wrapper" v-if="totoalPage!=0 &&totoalPage>12">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="currentPage"
                @current-change="handleCurrentChange"
                :page-size="10"
                :total="totoalPage">
              </el-pagination>
            </div>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  const TYPE2 = '显示全部';
  const TYPE3 = '选择时间查找';
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import middleNav from 'components/middlenav/MiddleNav'
  import aboveNav from 'components/abovenav/AboveNav'
  export default{
    data(){
      return {
        id: (() => {
          return loadLocal('id', false);
        })(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        classinfo: (() => loadLocal('classinfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        middleList: [
          {
            name: '课程表',
            to: '/console/lesson/class/schedule',
          },
          {
            name: '班级成员',
            to: '/console/lesson/class/member',
          }
        ],
        //----课时信息-----//
        classHourInfo: null,
        //-----------表示总数-------------------//
        totoalPage: 0,
        //----------收费班列表-------------------//
        costList: [],
        //-----------以下内容和筛选有关-----------//
        radioSelect: '显示全部',
        oldRadioSelect: '显示全部',
        timepickShow: false,
        date: [new Date(), new Date()],
        oldDate: [new Date(), new Date()],
        //-----------试听班列表-----------//
        freeList: [],
        currentPage: 1,

      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeTotalHour(item) {
        let hour = Math.floor(item / 60);
        let minutes = item % 60;
        return `${hour}小时${minutes}分钟`
      },
      //获取收费课程的成员列表
      QueryCostUser(pageNumber){
        this.orderList = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassUser',
            a: 'QueryClassUser',
            id: this.id,
            rid: this.classinfo.rid,
            lessonid: this.lessoninfo.id,
            classid: this.classinfo.id,
            pageno: pageNumber,
            pagesize: 10,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.costList = response.list;
            this.totoalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //用户打开时间选择后，点击搜索
      search(){
        //如果时间为空，则给予提示
        if (this.date == null) {
          this.$message({
            message: '请输入时间！',
            type: 'waring'
          });
        } else {
          //如果时间不为空，则将oldRadioSelect置为第三种状态，同时oldDate设为date（此种情况可以预防用户选择时间查询后，清空时间，同时点击下一页）
          this.oldRadioSelect = TYPE3;
          this.oldDate = this.date;
          let params = this.conputeXHRParams(1);
          this.currentPage = 1;
          this.QueryFreeUser(params);
        }
      },
      //根据用户选择的选项，计算XHR请求的参数
      conputeXHRParams(pageNumber){
        let params = {
          c: 'ClassUser',
          a: 'QueryClassUser',
          id: this.id,                //sessionid
          rid: this.classinfo.rid,
          lessonid: this.lessoninfo.id,
          classid: this.classinfo.id,
          pageno: pageNumber,
          pagesize: 12,
          count: 1
        };
        //根据old选择的是什么，重新将当前的选择置为old的选择（即如果用户点击了‘显示全部’，再点击了‘选择时间查找’，并没有点查询，则用户点击下一页时，应当将单选框重置为‘显示近期课程’）
        this.radioSelect = this.oldRadioSelect;
//        if (this.oldRadioSelect === TYPE1) {
//          //‘显示近期课程’是需要设置querystartdate参数的
//          let date = new Date();
//          params.querystartdate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
//        } else
        if (this.oldRadioSelect === TYPE3) {
          //如用户选择时间并查找后，清空了时间，同时点击下一步，应当让时间重新置为之前选择的时间
          this.date = this.oldDate;
          let startDate = this.oldDate[0];
          let endDate = this.oldDate[1];
          let start = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
          let end = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
          params.querystartdate = start;
          let interval = ( Math.abs(Date.parse(end) - Date.parse(start)) ) / 1000 / 60 / 60 / 24;
          params.querydays = interval + 1;
        }
        return params;
      },
      //获取试听课程的成员列表
      QueryFreeUser(params){
        this.freeList = [];
        this.totoalPage = 0;
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let originalList = response.list;
            let result = [];
            outside:
              for (let i = 0; i < originalList.length; i++) {
                if (result.length === 0) {
                  let first = {};
                  first.time = originalList[i].startdate.substring(0, 10);
                  first.list = [];
                  first.list.push(originalList[i]);
                  result.push(first);
                  continue;
                }
                for (let j = 0; j < result.length; j++) {
                  if (originalList[i].startdate.substring(0, 10) === result[j].time) {
                    result[j].list.push(originalList[i]);
                    continue outside;
                  }
                }
                let item = {};
                item.time = originalList[i].startdate.substring(0, 10);
                item.list = [];
                item.list.push(originalList[i]);
                result.push(item);
              }
            this.freeList = result;
            this.totoalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //改变页码时
      handleCurrentChange(val) {
        let params = this.conputeXHRParams(val);
        this.QueryFreeUser(params);
        this.$forceUpdate();
      },
      queryClassHour() {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHour',
            a: 'QueryClassHour',
            id: this.id,
            classid: this.classinfo.id,
            catalog_index: this.classinfo.catalog_index,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classHourInfo = response.list[0];
          }
        }).catch((err) => {

        })
      }
    },
    watch: {
      //根据用户选择单选按钮，做出的操作
      radioSelect(){
        if (this.radioSelect === TYPE3) {
          this.timepickShow = true;
          this.date = this.oldDate;
        } else {
          //隐藏选择时期
          this.timepickShow = false;
          //设置oldoldRadioSelect，请请求数据
          this.oldRadioSelect = this.radioSelect;
          let params = this.conputeXHRParams(1);
          this.currentPage = 1;
          this.QueryFreeUser(params);
        }
      }
    },
    created(){
      //如果是收费班，则调用QueryCostUser方法
      if (this.classinfo.democlass === '0') {
        this.QueryCostUser(1);
        this.queryClassHour();
      } else if (this.classinfo.democlass === '1') {
        let params = this.conputeXHRParams(1);
        this.QueryFreeUser(params);
      }
    },
    components: {
      aboveNav,
      middleNav,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .class-member
    position fixed
    left: 160px
    top: 40px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    .content-wrapper
      padding: 20px 0
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin-left: 20px
        padding-bottom: 20px
        width: 1166px
        .back
          width: 124px
          height: 34px
          line-height: 34px
          font-size: 14px
          color: #999
          text-align: center
          cursor pointer
          background: #fff
        .classinfo-wrapper
          margin: 20px 0
          padding: 30px
          height: 120px
          background: #fff
          .info-img
            float: left
            border-radius: 4px
          .classinfo-text-wrapper
            float: left
            margin-left: 20px
            .classinfo-text-title
              margin-bottom: 20px
              font-size: 24px
              color: #333
              font-weight: bold
              height: 31px
              line-height: 31px
            .classinfo-text-row
              margin-bottom: 12px
              font-size: 14px
              color: #a5a5a5
              height: 19px
              line-height: 19px
              .split {
                position: relative
                top: 3px
                display: inline-block
                height: 15px
                width: 1px
                margin: 0 20px
                background: #a5a5a5
              }
        .member-wrapper
          background: #fff
          padding-bottom:10px
          .enrollnum
            padding-top: 30px
            margin: 0 0 0 50px
            font-size: 14px
            color: #555555
            font-weight: bold
          .hint
            margin: 50px 0
            text-align: center
            font-size: 14px
            color: #aeaeae
            line-height: 20px
          .list-wrapper
            margin: 20px 50px
            &.no-margin
              margin: 20px 0
            .list
              display inline-block
              margin: 0 20px 20px 0
              padding: 30px 0 15px 25px
              width: 342px
              height: 202px
              border: 1px solid #e4e4e4
              box-sizing border-box
              &:nth-child(3n)
                margin-right: 0
              img
                vertical-align top
              .text-wrapper
                display inline-block
                margin-left: 20px
                .name
                  font-size: 18px
                  color: #000000
                  font-weight: bold
                  height: 24px
                  line-height: 24px
                  text-overflow ellipsis
                  overflow hidden
                  white-space nowrap
                .phone
                  height: 20px
                  line-height: 20px
                  margin: 10px 0 40px
                  font-size: 14px
                  color: #555
                  font-weight: bold
                  text-overflow ellipsis
                  overflow hidden
                  white-space nowrap
                .pay
                  font-size: 12px
                  color: #888888

              .time
                margin-top: 29px
                font-size: 12px
                color: #ccc
          .filter-wrapper
            margin: 10px 50px 0
            padding-left: 15px
            height: 48px
            line-height: 48px
            box-sizing border-box
            background #fafafa
            .timepicker
              margin-left: 20px
              position relative
              top: 3px
            .search
              position relative
              top: 4px
              display: inline-block
              margin-left: 10px
              height: 28px
              line-height: 28px
              width: 60px
              text-align: center
              font-size: 14px
              color: #704000
              background #ffcc66
              border-radius 4px
              cursor: pointer

          .time-title
            margin: 20px 50px
            .opendate
              display inline-block
              padding: 0 12px
              height: 30px
              line-height 30px
              font-size: 14px
              color: #ffffff
              font-weight: bold
              background #3399ff
              border-top-left-radius: 4px
              border-top-right-radius 4px
              position relative
              &::before
                position absolute
                content: ''
                left: 0
                top: 30px
                width: 0
                height: 0
                border-color: #3399ff #fff #fff #fff
                border-style: solid
                border-width: 5px 10px 0 10px

          .pagenav-wrapper
            margin: 0px 50px
</style>



// WEBPACK FOOTER //
// src/page/class/classmember/ClassMember.vue